'use strict';

var _ = require('lodash');
var Draw = require('./Draw');

var DrawMarker = Draw.extend({
  constructor: function (map, options, Actions, Store) {
    var DEFAULT_OPTIONS = {
      icon: L.divIcon({
        html: '<div style="display: none;"></div>',
        iconSize: [0,0]
      })
    };
    
    // keys that Leaflet.draw accepts for this layer type
    this.drawOptionKeys = ['icon', 'zIndexOffset', 'repeatMode'];

    options = _.extend(DEFAULT_OPTIONS, options);
    Draw.call(this, map, options, Actions, Store);
  },

  _newDraw: function (options) {
    var map = this.map;
    return new L.Draw.Marker(map, options);
  }
});

module.exports = DrawMarker;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/handlers/DrawMarker.js